import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./AdminSidebar.css";

const AdminSidebar = () => {
  const { currentUser, isAgentAdmin, isSuperAdmin } = useAuth();
  const location = useLocation();

  // Determine if a path is active
  const isActive = (path) => location.pathname.includes(path);

  return (
    <div className="admin-sidebar">
      <div className="sidebar-header">
        <div className="admin-avatar">
          {currentUser?.name ? currentUser.name.charAt(0).toUpperCase() : "A"}
        </div>
        <div className="admin-info">
          <h3>{currentUser?.name || "Administrator"}</h3>
          <p>{currentUser?.email || "admin@example.com"}</p>
          <p className="user-role">
            {currentUser?.role === "admin" ||
            currentUser?.role === "super_admin"
              ? "Super Admin"
              : "Agent Admin"}
          </p>
        </div>
      </div>

      <nav className="sidebar-nav">
        <ul>
          {/* Dashboard - different for agent and super admin */}
          {isSuperAdmin() && (
            <li className={isActive("/admin-dashboard") ? "active" : ""}>
              <Link to="/admin-dashboard">
                <i className="fa fa-tachometer-alt"></i> Dashboard
              </Link>
            </li>
          )}

          {isAgentAdmin() && (
            <li className={isActive("/agent-dashboard") ? "active" : ""}>
              <Link to="/agent-dashboard">
                <i className="fa fa-tachometer-alt"></i> Dashboard
              </Link>
            </li>
          )}

          {/* Agent admin specific links */}
          {isAgentAdmin() && (
            <>
              <li
                className={isActive("/agent/agency-requests") ? "active" : ""}
              >
                <Link to="/agent/agency-requests">
                  <i className="fa fa-user-plus"></i> Agency Membership Requests
                </Link>
              </li>

              <li
                className={isActive("/agent/booking-requests") ? "active" : ""}
              >
                <Link to="/agent/booking-requests">
                  <i className="fa fa-calendar-plus"></i> Booking Requests
                </Link>
              </li>

              <li className={isActive("/bookings/create") ? "active" : ""}>
                <Link to="/bookings/create">
                  <i className="fa fa-plus-circle"></i> Create Booking
                </Link>
              </li>
            </>
          )}

          {/* Super admin specific links */}
          {isSuperAdmin() && (
            <>
              <li className={isActive("/admin/agencies") ? "active" : ""}>
                <Link to="/admin/agencies">
                  <i className="fa fa-building"></i> Agencies
                </Link>
              </li>

              <li className={isActive("/admin/agent-admins") ? "active" : ""}>
                <Link to="/admin/agent-admins">
                  <i className="fa fa-users"></i> Agent Admins
                </Link>
              </li>

              <li className={isActive("/admin/lots") ? "active" : ""}>
                <Link to="/admin/lots">
                  <i className="fa fa-home"></i> Lots
                </Link>
              </li>

              <li className={isActive("/admin/bookings") ? "active" : ""}>
                <Link to="/admin/bookings">
                  <i className="fa fa-calendar-check"></i> Booking Approvals
                </Link>
              </li>

              <li className={isActive("/admin/all-bookings") ? "active" : ""}>
                <Link to="/admin/all-bookings">
                  <i className="fa fa-calendar"></i> All Bookings
                </Link>
              </li>

              <li className={isActive("/admin/users") ? "active" : ""}>
                <Link to="/admin/users">
                  <i className="fa fa-user"></i> Users
                </Link>
              </li>
            </>
          )}

          {/* Common links */}
          <li className={isActive("/profile") ? "active" : ""}>
            <Link to="/profile">
              <i className="fa fa-id-card"></i> My Profile
            </Link>
          </li>
        </ul>
      </nav>

      <div className="sidebar-footer">
        <p>© {new Date().getFullYear()} AeroIndustrialHub</p>
      </div>
    </div>
  );
};

export default AdminSidebar;
